import {
  Box,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material';
import React, { useContext, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { FormattedMessage } from 'react-intl';
import '../../../../App.css';

interface HeaderButtonsProps {
  language: string;
  onSelectLanguage: (item: string) => void;
}

const ListWrapper = styled(Box)(
  ({ theme }) => `
        .MuiTouchRipple-root {
            display: none;
        }
        
        .MuiListItem-root {
            transition: ${theme.transitions.create(['color', 'fill'])};
            
            &.MuiListItem-indicators {
                padding: ${theme.spacing(1, 2)};
            
                .MuiListItemText-root {
                    .MuiTypography-root {
                        &:before {
                            height: 4px;
                            width: 22px;
                            opacity: 0;
                            visibility: hidden;
                            display: block;
                            position: absolute;
                            bottom: -10px;
                            transition: all .2s;
                            border-radius: ${theme.general.borderRadiusLg};
                            content: "";
                            background: ${theme.colors.primary.main};
                        }
                    }
                }

                &.active,
                &:active,
                &:hover {
                
                    background: transparent;
                
                    .MuiListItemText-root {
                        .MuiTypography-root {
                            &:before {
                                opacity: 1;
                                visibility: visible;
                                bottom: 0px;
                            }
                        }
                    }
                }
            }
        }
`
);

function HeaderMenu(props: HeaderButtonsProps) {
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const themeContext = useContext(ThemeContext);
  if (!themeContext) {
    return null;
  }
  const setThemeName = themeContext;

  const [darkState, setDarkState] = useState(false);

  const handleThemeChange = () => {
    setDarkState(!darkState);
    if (darkState == false) {
      setThemeName('NebulaFighterTheme');
      localStorage.setItem('theme', 'NebulaFighterTheme');
    } else {
      setThemeName('PureLightTheme');
      localStorage.setItem('theme', 'PureLightTheme');
    }
  };

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleLanguageSelect = (language) => {
    props.onSelectLanguage(language);
    handleClose();
  };

  const isMobile = window.innerWidth <= 1280;

  return (
    <div style={{ userSelect: 'none' }}>
      <ListWrapper
        sx={{
          color: isMobile ? 'white' : ''
        }}
      >
        <List disablePadding component={Box} display="flex">
          <ListItem
            classes={{ root: 'MuiListItem-indicators' }}
            ref={ref}
            onClick={handleOpen}
          >
            <ListItemText
              primaryTypographyProps={{ noWrap: true }}
              primary={
                <Box display="flex" alignItems="center">
                  <FormattedMessage id="language" defaultMessage="Language" />
                  <Box display="flex" alignItems="center" pl={0.3}>
                    <ExpandMoreTwoToneIcon fontSize="small" />
                  </Box>
                </Box>
              }
            />
          </ListItem>
        </List>
      </ListWrapper>
      <div
        style={{ userSelect: 'none', pointerEvents: 'none', cursor: 'default' }}
      >
        <Menu anchorEl={ref.current} onClose={handleClose} open={isOpen}>
          <MenuItem value="en" onClick={() => handleLanguageSelect('en')}>
            English
          </MenuItem>
          <MenuItem value="de" onClick={() => handleLanguageSelect('de')}>
            German
          </MenuItem>
          <MenuItem value="fr" onClick={() => handleLanguageSelect('fr')}>
            French
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
}

export default HeaderMenu;
